import ButtonSimple from './ButtonSimple';

const STATE_ON = 1;
const STATE_OFF = 2;
const STATE_HIDING = 3;
const STATE_SHOWING = 4;

export default class ButtonArrow extends ButtonSimple {
  constructor({
    game,
    x = 0,
    y = 0,
    up,
    over,
    atlas = 'ui_buttons',
    playClick = true,
    sfxID = 'generic_ui',
  }) {
    super({
      game,
      x,
      y,
      up,
      over,
      atlas,
      playClick,
      sfxID,
    });

    this.state = STATE_ON;
  }

  setVisibility(visible) {
    if (visible) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    if (this.state === STATE_OFF || this.state === STATE_HIDING) {
      this.state = STATE_SHOWING;
      if (this.tween) this.tween.stop();

      this.tween = this.game.add.tween(this).to({ alpha: 1 }, 100, null, true);
      this.tween.onComplete.addOnce(this.handleShowEnd, this);
    }
  }

  handleShowEnd() {
    this.state = STATE_ON;
    this.tween = null;

    this.enable();
  }

  hide(instant) {
    if (instant) {
      this.alpha = 0;
      this.disable();
      this.handleHideEnd();
    } else if (this.state === STATE_ON || this.state === STATE_SHOWING) {
      this.state = STATE_HIDING;
      if (this.tween) this.tween.stop();

      this.disable();

      this.tween = this.game.add.tween(this).to({ alpha: 0 }, 100, null, true);
      this.tween.onComplete.addOnce(this.handleHideEnd, this);
    }
  }

  handleHideEnd() {
    this.state = STATE_OFF;
    this.tween = null;
  }
}
